export default __webpack_public_path__ + "static/media/kimura.e78488d2.jpeg";